"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _utils = require("./utils");
var _locales = require("libs/utils/locales");
var _lodash = require("lodash");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } // bsFormGeneratorField
var _require = require('src/fp-i18n-utils'),
  getAllI18nKeys = _require.getAllI18nKeys;
var getDefaultModelForDescriptor = function getDefaultModelForDescriptor(fieldDescriptor) {
  var _fieldDescriptor$kind;
  var fields = fieldDescriptor === null || fieldDescriptor === void 0 || (_fieldDescriptor$kind = fieldDescriptor.kind_options) === null || _fieldDescriptor$kind === void 0 ? void 0 : _fieldDescriptor$kind.fields;
  if (!Array.isArray(fields)) {
    return;
  }
  return fields.reduce(function (model, field) {
    if (field !== null && field !== void 0 && field.default) {
      model[field.field] = field.default;
    }
    return model;
  }, {});
};
var sharedLinkFns = {
  // this is required due to the weird way angular deals with nested directives that are the "same" (by name)
  generateFormGeneratorFieldNestedObjectRenderer: function generateFormGeneratorFieldNestedObjectRenderer($compile, $templateCache, $timeout, addRevealingInputDirective) {
    if (addRevealingInputDirective === null) {
      addRevealingInputDirective = false;
    }
    var nestedEditorPlaceholderFallbackHtml = require('angular/directives/formFieldNestedObjectPlaceholder');
    return function (scope, elem) {
      if (scope.fieldDescriptor.kind !== 'nested-object') {
        return;
      }
      scope.getDefaultModelForDescriptor = function () {
        return getDefaultModelForDescriptor(scope.fieldDescriptor);
      };
      var extraButtonAttributes = '';
      if (addRevealingInputDirective) {
        extraButtonAttributes += 'data-bs-revealing-input ';
        extraButtonAttributes += 'data-prop-to-toggle="disabled"';
      }
      var nestedEditorHtml = $templateCache.get('/static/partials/components/form-generator-field-nested-object-editor.html');

      // it might not be in the cache if we're not using the template cache (for e.g. in dev mode)
      if (!nestedEditorHtml) {
        // load the placeholder (html from a module. bad bad)
        nestedEditorHtml = nestedEditorPlaceholderFallbackHtml;
      }
      nestedEditorHtml = nestedEditorHtml.replace('data-extra-button-attributes-placeholder=""', extraButtonAttributes);

      // modal open state is contained within an object because ng seems to handle that better
      var nestedEditorRequiredScope = {
        viewState: {
          isEditorModalOpen: false
        }
      };
      angular.extend(scope, nestedEditorRequiredScope);

      // "arrayify" nested fields
      var opts = function opts() {
        return scope.fieldDescriptor.kind_options;
      };
      if (!_.isArray(opts().fields) && _.isObject(opts().fields)) {
        opts().fields = _.pairs(opts().fields).reduce(function (arr, pair) {
          arr.push(_.extend(pair[1], {
            field: pair[0]
          }));
          return arr;
        }, []);
      }
      $timeout(function () {
        elem.find('td ng-form').prepend(nestedEditorHtml);
        $compile(elem.contents())(scope);
      });
    };
  }
};
var FormGeneratorFieldCtrl = /* @ngInject */function FormGeneratorFieldCtrl($log, $rootScope, $filter, $scope, $timeout, $route, i18nService, metadataService, modalService, settingsService) {
  var _$route$current;
  var kindOptions, openI18nEditorForKeyFn, protectedFields;
  var ADD_NEW_I18N_PLACEHOLDER_VAL = $scope.ADD_NEW_I18N_PLACEHOLDER_VAL = '_ADD_NEW_I18N_';

  // only vue controllers have a componentName
  var isVueControler = Boolean($route === null || $route === void 0 || (_$route$current = $route.current) === null || _$route$current === void 0 || (_$route$current = _$route$current.blueprintMetadata) === null || _$route$current === void 0 || (_$route$current = _$route$current.controller) === null || _$route$current === void 0 ? void 0 : _$route$current.componentName);
  var event = $rootScope.event;
  var humanize = $filter('humanize');
  var uppercaseFirstChar = $filter('uppercaseFirstChar');
  var getFieldLabel = function getFieldLabel() {
    var fieldLabel = $scope.fieldDescriptor.label || $scope.field;
    return uppercaseFirstChar(humanize(fieldLabel));
  };
  $scope.visible = true;
  if ($scope.fieldDescriptor.kind === 'hidden') {
    var _$scope$fieldDescript;
    var isUnchangeable = $scope.fieldDescriptor.field._editable === false;
    $scope.visible = ((_$scope$fieldDescript = $scope.fieldDescriptor.kind_options) === null || _$scope$fieldDescript === void 0 ? void 0 : _$scope$fieldDescript.hidden) === false;
    $scope.notEditable = isUnchangeable;
  }
  function checkVisibility() {
    return _checkVisibility.apply(this, arguments);
  }
  function _checkVisibility() {
    _checkVisibility = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var settingsCond, visible, _iterator, _step, _step$value, path, value;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            settingsCond = (0, _lodash.get)($scope.fieldDescriptor, 'conditions.settings');
            if (!Array.isArray(settingsCond)) {
              _context2.next = 27;
              break;
            }
            visible = false;
            _iterator = _createForOfIteratorHelper(settingsCond);
            _context2.prev = 4;
            _iterator.s();
          case 6:
            if ((_step = _iterator.n()).done) {
              _context2.next = 17;
              break;
            }
            _step$value = _step.value, path = _step$value.path, value = _step$value.value;
            _context2.next = 10;
            return settingsService.getSetting(event._id, path);
          case 10:
            _context2.t0 = _context2.sent;
            _context2.t1 = value;
            visible = _context2.t0 === _context2.t1;
            if (visible) {
              _context2.next = 15;
              break;
            }
            return _context2.abrupt("break", 17);
          case 15:
            _context2.next = 6;
            break;
          case 17:
            _context2.next = 22;
            break;
          case 19:
            _context2.prev = 19;
            _context2.t2 = _context2["catch"](4);
            _iterator.e(_context2.t2);
          case 22:
            _context2.prev = 22;
            _iterator.f();
            return _context2.finish(22);
          case 25:
            $scope.visible = visible;
            return _context2.abrupt("return", visible);
          case 27:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[4, 19, 22, 25]]);
    }));
    return _checkVisibility.apply(this, arguments);
  }
  checkVisibility();
  if ($scope.isBulkEdit) {
    // to initialize the variables so we always send them (when checked) even if empty
    $scope.model[$scope.fieldDescriptor.field] = null;
  }
  $scope.checkRequiredField = function (fieldDescriptor) {
    var isRequired = (0, _lodash.get)(fieldDescriptor, 'validations.required');

    // for bulk editable forms, we also check if the checkbox is selected to consider the field as required
    // for normal forms, we only consider the validation of the field
    if ($scope.isBulkEdit) {
      return isRequired && $scope.checkedFields[fieldDescriptor.field];
    }
    return isRequired;
  };
  var fieldsToIgnore = function fieldsToIgnore(field, newValue, oldValue) {
    return (
      // custom fields
      field.kind === 'custom' ||
      // eg: data filters in forms SS-9881
      field.kind === 'nested-object' && ((0, _lodash.isEmpty)(newValue) || !(0, _lodash.get)(oldValue, 'context') && (0, _lodash.get)(newValue, 'context')) || field.kind === 'list' && !(0, _lodash.get)(oldValue, '[0].context') && newValue && (0, _lodash.get)(newValue, '[0].context') ||
      // icon fields get initialized
      field.field === 'icon' && !newValue
    );
  };

  // we watch the fields to mark automatically the checkbox if someone starts typing
  $scope.$watch('model[fieldDescriptor.field]', function (newValue, oldValue) {
    if (newValue !== oldValue && JSON.stringify(newValue) !== JSON.stringify(oldValue) && (
    // quick check for objects
    newValue || oldValue)) {
      // at least one has values (escape null and undefined cases)

      if (!isVueControler && !fieldsToIgnore($scope.fieldDescriptor, newValue, oldValue)) {
        // the custom case generates many different outputs so we ignore it due to too many false positives
        // we do not add warning when we are inside a vue controller, vue will handle the warnings, not angular
        $rootScope.setNavigationWarningMessage("You may have intended to change the ".concat(getFieldLabel(), " but you have not saved the form. ") + 'Discard your selection?');
      }
      if ($scope.isBulkEdit) {
        if ($scope.fieldDescriptor.kind === 'nested-object' && ((0, _lodash.isEmpty)(newValue) || (0, _lodash.isEqual)(newValue, getDefaultModelForDescriptor($scope.fieldDescriptor)))) {
          return;
        }
        if (newValue && !$scope.checkedFields[$scope.fieldDescriptor.field]) {
          $scope.checkedFields[$scope.fieldDescriptor.field] = true;
        }
      }
    }
  }, true);
  if ($scope.isBulkEdit && $scope.fieldDescriptor.kind === 'external' && ($scope.fieldDescriptor.kind_options || {}).type === 'targets-exceptions') {
    $scope.$watch('model.exceptions', function (newValue) {
      if (newValue && !$scope.checkedFields[$scope.fieldDescriptor.field]) {
        $scope.checkedFields[$scope.fieldDescriptor.field] = true;
      }
    });
  }
  $scope.select2Options = {
    placeholder: 'Select an option',
    minimumResultsForSearch: 6
  };

  // choice kind values filtering logic

  var filteredKindOptionsValues = [];

  // for choice kind make sure the model is a string
  var modelValue = $scope.model[$scope.fieldDescriptor.field];
  if ($scope.fieldDescriptor.kind === 'choice' && typeof modelValue === 'number') {
    $scope.model[$scope.fieldDescriptor.field] = modelValue.toString();
  }
  var refreshFilteredKindOptionsValues = function refreshFilteredKindOptionsValues(newValues, oldValues) {
    if (newValues === oldValues) {
      // don't bother if ref is the same, target NEW descriptors with new values
      return;
    }
    var kindOptions = $scope.fieldDescriptor.kind_options || {};
    if (!_.isObject(kindOptions.values)) {
      return;
    }
    filteredKindOptionsValues = metadataService.getChoiceOptionsOrderedList(kindOptions);
  };
  refreshFilteredKindOptionsValues(true); // force

  kindOptions = $scope.fieldDescriptor.kind_options;
  if (kindOptions) {
    if (kindOptions.prefill) {
      $scope.defaultDatePickerDate = (event !== null ? event.startdate : undefined) || null;
    }
    refreshFilteredKindOptionsValues();
  }
  if (_.isArray(protectedFields = $scope.model !== null ? $scope.model.fp_protected : undefined)) {
    $scope.isProtectedField = Array.from(protectedFields).includes($scope.fieldDescriptor !== null ? $scope.fieldDescriptor.field : undefined);
  }
  $scope.getKindOptionsValues = function () {
    return filteredKindOptionsValues;
  };

  // this watcher will remove nulled out values when the descriptor changes (for instance in the panes of the prefs controller)
  $scope.$watch('fieldDescriptor.kind_options.values', refreshFilteredKindOptionsValues, true);
  $scope.omitFieldLabelFinal = ['boolean', 'external'].includes($scope.fieldDescriptor.kind) ? true : $scope.omitFieldLabel;
  if ($scope.fieldDescriptor.never_show_label) {
    $scope.omitFieldLabelFinal = true;
  }
  if ($scope.fieldDescriptor.always_show_label) {
    $scope.omitFieldLabelFinal = false;
  }
  if ($scope.fieldDescriptor.kind === 'locale') {
    $scope.omitFieldLabelFinal = true;
  }

  // embed kind logic

  if ($scope.fieldDescriptor.kind === 'embed') {
    $scope.$watch('model[fieldDescriptor.field]', function (value) {
      if (!value) {
        return;
      }
      var transformed = (0, _utils.transformToEmbeddedUrls)(value);
      if (transformed !== value) {
        // give a bit of delay so the user sees that the value was processed
        $timeout(function () {
          $scope.model[$scope.fieldDescriptor.field] = transformed;
        }, 500);
      }
    });
  }

  // !!! ALL THAT FOLLOWS IS i18n SELECTOR ONLY LOGIC !!!

  if ($scope.fieldDescriptor.kind !== 'i18n') {
    return;
  }
  var i18n = null;
  $scope.availableI18nKeys = {};
  i18nService.retrieveCompiledI18n(event).then(function (_i18n) {
    var _preselectedI18nKey;
    i18n = _i18n;
    var availableI18nKeys = getAllI18nKeys(i18n).reduce(function (map, key) {
      map[key] = key;
      return map;
    }, {});
    angular.copy(availableI18nKeys, $scope.availableI18nKeys);
    $scope.i18nSelectionsLoaded = true;

    // prime the preview if we already have an i18n key set
    if (_.isEmpty($scope.selectedI18nValue) && (_preselectedI18nKey = $scope.model[$scope.fieldDescriptor.field])) {
      return $scope.selectedI18nValue = getSelectedI18nValueFn(_preselectedI18nKey);
    }
  });
  $scope.i18nSelect2Options = {
    placeholder: 'Select a shared translation',
    formatResult: function formatResult(result) {
      if ((result !== null ? result.id : undefined) !== ADD_NEW_I18N_PLACEHOLDER_VAL) {
        return result.text;
      }
      return "<i class=\"icon-circle-with-plus\"></i> ".concat(result.text);
    }
  };
  $scope.$watch('model[fieldDescriptor.field]', function (selectedI18nKey, previousI18nKey) {
    $scope.selectedI18nValue = getSelectedI18nValueFn(selectedI18nKey);
    if (selectedI18nKey !== ADD_NEW_I18N_PLACEHOLDER_VAL) {
      return;
    }
    modalService.openModalWithForm({
      title: 'Add a new translation key',
      fields: {
        key: {
          order: 1,
          validations: {
            custom: {
              errorMessage: 'Chosen key is either invalid, reserved, or already used.'
            }
          }
        }
      },
      formCanBeSaved: function formCanBeSaved(model, form) {
        var valid = (0, _locales.validateNewI18nKey)(model.key, i18n);
        var field = (0, _lodash.get)(form, 'genericFieldForm.key');
        if (field) {
          field.$setValidity('customValidator', valid);
        }
        return valid;
      }
    }).then(function (model) {
      var i18nKeyToCreate = model.key;
      // restores old value until new i18n key is created and saved
      // surprass prevent {{#spotme.tr}}null{{/spotme.tr}} in the preview

      $scope.model[$scope.fieldDescriptor.field] = previousI18nKey;
      if (!(i18nKeyToCreate !== null ? i18nKeyToCreate.length : undefined)) {
        return;
      }
      return openI18nEditorForKeyFn(i18nKeyToCreate);
    });
  });
  $scope.showAddI18nLanguageToMetadataPrompt = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(i18nFields) {
      var langs, langCode;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            langs = i18nFields.map(function (l) {
              return l.field;
            });
            _context.next = 3;
            return modalService.openModal({
              templateUrl: '/static/partials/components/modal-language-picker.html',
              scope: {
                lang: '',
                langs: langs
              }
            });
          case 3:
            langCode = _context.sent;
            if (langCode.length) {
              _context.next = 6;
              break;
            }
            return _context.abrupt("return");
          case 6:
            i18nFields.push({
              field: langCode,
              label: langCode.toUpperCase()
            });
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();

  /* helper methods */

  var saveI18nUpdates = function saveI18nUpdates(i18nKey, i18nValue) {
    var errCb = function errCb(err) {
      alert('There was a problem updating the i18n dictionary.');
      return $log.error('i18n save error!', err);
    };
    return i18nService.updateOverrideNavBitWithSingleEdit(event, i18nKey, i18nValue).then(function () {
      $scope.availableI18nKeys[i18nKey] = i18nKey;
      (0, _lodash.set)(i18n, i18nKey, i18nValue);
      $scope.model[$scope.fieldDescriptor.field] = i18nKey;
      return $rootScope.setFlashMessage('The i18n dictionary was updated.');
    }, errCb);
  };
  var getSelectedI18nValueFn = $scope.getSelectedI18nValue = function (i18nKey) {
    if (i18nKey === null) {
      i18nKey = $scope.model[$scope.fieldDescriptor.field];
    }
    if (!i18nKey) {
      return;
    }
    return (0, _lodash.get)(i18n, i18nKey) || {};
  };
  return openI18nEditorForKeyFn = $scope.openI18nEditorForKey = function (i18nKey) {
    if (!i18n) {
      return;
    }
    var selectedI18nValue = $scope.selectedI18nValue;
    return modalService.openModal({
      templateUrl: '/static/partials/components/modal-i18n-editor.html',
      scope: {
        selectedI18nKey: i18nKey,
        selectedI18nValueForEdit: selectedI18nValue,
        selectedI18nMetadata: i18nService.getMetadataForI18nEditor(selectedI18nValue),
        showAddI18nLanguageToMetadataPrompt: $scope.showAddI18nLanguageToMetadataPrompt
      }
    }).then(_.bind(saveI18nUpdates, null, i18nKey, selectedI18nValue));
  };
};
FormGeneratorFieldCtrl.$inject = ["$log", "$rootScope", "$filter", "$scope", "$timeout", "$route", "i18nService", "metadataService", "modalService", "settingsService"];
module.exports = /* @ngInject */["$compile", "$templateCache", "$timeout", function ($compile, $templateCache, $timeout) {
  return {
    scope: {
      model: '=',
      fieldDescriptor: '=',
      omitFieldLabel: '=',
      useTimestampForDates: '=',
      showRemoveFieldLink: '=',
      isRevealing: '=',
      showAddButtonInHeaderOfExternalFieldWidgets: '=',
      saveFn: '&',
      removeFieldFn: '&',
      isBulkEdit: '=',
      checkedFields: '=',
      bulkFieldOptions: '='
    },
    templateUrl: '/static/partials/components/form-generator-field.html',
    controller: FormGeneratorFieldCtrl,
    link: sharedLinkFns.generateFormGeneratorFieldNestedObjectRenderer($compile, $templateCache, $timeout)
  };
}];